import { useState } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from "react-router-dom";
import GuardDrawer from './GuardDrawer';
import GuardAppBar from './GuradAppBar';
import { Container, useMediaQuery } from '@mui/material';
import { HelpCenter } from 'src/components/common';

export default function ClippedDrawer() {
    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));
    const [openDrawer, setOpenDrawer] = useState(false)
    const toggleDrawerHandler = () => {
        setOpenDrawer((prevState) => !prevState)
    }
    return (
        <Box sx={{ display: downLg ? '' : 'flex' }}>
            <CssBaseline />
            <GuardAppBar toggleDrawer={toggleDrawerHandler} />
            <GuardDrawer openDrawer={openDrawer} toggleDrawer={toggleDrawerHandler} />
            <HelpCenter />
            {/* minWidth: 0 lets <main> shrink to the space beside the drawer; without it wide tables/tab rows
                push the page past the viewport, where html's overflow-x: hidden makes it unreachable */}
            <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: 2 }}>
                <Toolbar />
                <Container maxWidth={false}>
                    <Outlet />
                </Container>
            </Box>
        </Box>
    );
}